import {BrowserRouter, Route, Routes} from "react-router-dom";
import SelfAssessment from "./pages/SelfAssessment";
import Login from "./pages/Login";
import Register from "./pages/Register";
import User from "./pages/User";
import Competency from "./pages/Competency";
import './App.css'

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Quarter from "./pages/Quarter";
import Assestment from "./pages/Assestment";
import AssestmentTitle from "./pages/AssestmentTitle";
import AssestmentTitleIndicator from "./pages/AssestmentTitleIndicator";
import AssesmentOpinion from "./pages/AssesmentOpinion";
import CompetencyOpinion from "./pages/CompetencyOpinion";
import UserRole from "./pages/RoleName";
import UserRoleNames from "./pages/UserRoleNames";
import SupervisorAssessmentPage from "./pages/SupervisorAssessmentPage";
import GridFilterDemo from './pages/rnd/GridFilterDemo'
import Profile from "./pages/Profile";
import CompetencyTitleIndicator from "./pages/CompetencyTitleIndicator";

import SupervisorCompOpinion from "./pages/SupervisorCompOpinion";
import SelfCompetencyAssessment from "./pages/SelfCompetencyAssessment";
import SkillMatrix from "./pages/SkillMatrix";
import SuperVisorSkillMatrix from "./pages/SuperVisorSkillMatrix";
import MatrixOpinion from "./pages/MatrixOpinion";
import SuperVisorSkillMatrixDdl from "./pages/SuperVisorSkillMatrixDdl";
import RoleCompetencyRca from "./pages/RoleCompetencyRca";
import EmployeeMatrix from "./pages/EmployeeMatrix";
import MyIdp from "./pages/MyIdp";
import EmployeeIDP from "./pages/EmployeeIDP";
import IDPDetails from "./pages/IDPDetails";
import EmployeeStatus from "./pages/EmployeeStatus";
import ManagementDashboard from "./pages/ManagementDashboard";
import MarksSummary from "./pages/MarksSummary";
import MarksDetails from "./pages/MarksDetails";
import EmployeeWillMatrix from "./pages/EmployeeWillMatrix";
import EvaluationReport from "./pages/EvaluationReport";
import PasswordChange from "./pages/PasswordChange";
import SupervisorUpdate from "./pages/SupervisorUpdate";
import EmployeeInsert from "./pages/EmployeeInsert";
import ForgetPassword from "./pages/ForgetPassword";
import MatrixLibrary from "./pages/MatrixLibrary";
import MatrixLibraryCreate from "./pages/MatrixLibraryCreate";
import EmployeeWillMatrixAdmin from "./pages/EmployeeWillMatrixManagement";
import Contact from "./pages/Contact";
import EmployeeIDPAdmin from "./pages/EmployeeIDPAdmin";
import SupervisorUserEmailUpdate from "./pages/SupervisorUserEmailUpdate";
import EmployeeTaskList from "./pages/EmployeeTaskList";
import SupervisorRemarksForTaskList from "./pages/SupervisorRemarksForTaskList";
import EmployeeWiseActionPlan from "./pages/EmployeeWiseActionPlan";
import TaskListReport from "./pages/TaskListReport";
import TaskListDashboard from "./pages/EmployeeTaskDashboard";
import PMSCycleReport from "./pages/PMSCycleReport";
import EvaluationReportSummary from "./pages/EvaluationReportSummary";
import PromotionRecommendation from "./pages/PromotionRecommendation";
import PromotionRecommendationForHOD from "./pages/PromotionRecommendationForHOD";
import PromotionRecommendationForDivisionHead from "./pages/PromotionRecommendationForDivisionHead";
import PromotionRecommendationForHR from "./pages/PromotionRecommendationForHR";
import HeadSetup from "./pages/HeadSetup";
import EmployeePromotionReport from "./pages/EmployeePromotionReport";
import SupervisorUserMarks from "./pages/UserMarks_Supervisor";
import HodUserMarks from "./pages/UserMarks_HOD";
import DivisionHeadUserMarks from "./pages/UserMarks_DivisionHead";
import HRUserMarks from "./pages/UserMarks_HR";

function App() {
    return (
        <>
            <BrowserRouter basename='/PMS/'>
                <Routes>
                    <Route path="/" element={<Profile/>}/>
                    <Route path="MyIdp" element={<MyIdp/>}/>
                    <Route path="EmployeeIDP" element={<EmployeeIDP/>}/>
                    <Route path="IDPDetails" element={<IDPDetails/>}/>
                    <Route path="SupervisorAssessment" element={<SupervisorAssessmentPage/>}/>
                    <Route path="self-assessment" element={<SelfAssessment/>}/>
                    <Route path="assestmet" element={<Assestment/>}/>
                    <Route path="assestment-title" element={<AssestmentTitle/>}/>
                    <Route path="assesment-title-indicator" element={<AssestmentTitleIndicator/>}/>
                    <Route path="assesment-opinion" element={<AssesmentOpinion/>}/>
                    <Route path="competency" element={<Competency/>}/>
                    <Route path="competencyOpinion" element={<CompetencyOpinion/>}/>
                    <Route path="quarter" element={<Quarter/>}/>
                    <Route path="user" element={<User/>}/>
                    <Route path="profile" element={<Profile/>}/>
                    <Route path="login" element={<Login/>}/>
                    <Route path="register" element={<Register/>}/>
                    <Route path="rolename" element={<UserRole/>}/>
                    <Route path="userRoleNames" element={<UserRoleNames/>}/>
                    <Route path="gridDemo" element={<GridFilterDemo/>}/>
                    <Route path="competency-title-indicator" element={<CompetencyTitleIndicator/>}/>
                    <Route path="SupervisorCompetencyOpinion" element={<SupervisorCompOpinion/>}/>
                    <Route path="selfCompetencyAssessment" element={<SelfCompetencyAssessment/>}/>
                    <Route path="supervisorSkillMatrix" element={<SuperVisorSkillMatrixDdl/>}/>
                    <Route path="supervisorSkillMatrixDdl" element={<SuperVisorSkillMatrix/>}/>
                    <Route path="skillMatrix" element={<SkillMatrix/>}/>
                    <Route path="MatrixOpinion" element={<MatrixOpinion/>}/>
                    <Route path="RoleCompetencyRca" element={<RoleCompetencyRca/>}/>
                    <Route path="EmployeeMatrix" element={<EmployeeMatrix/>}/>
                    <Route path="EmployeeStatus" element={<EmployeeStatus/>}/>
                    <Route path="ManagementDashboard" element={<ManagementDashboard/>}/>
                    <Route path="MarksSummary" element={<MarksSummary/>}/>
                    <Route path="MarksDetails" element={<MarksDetails/>}/>
                    <Route path="EmployeeWillMatrix" element={<EmployeeWillMatrix/>}/>
                    <Route path="EvaluationReport" element={<EvaluationReport/>}/>
                    <Route path="PasswordChange" element={<PasswordChange/>}/>
                    <Route path="supervisor-update" element={<SupervisorUpdate/>}/>
                    <Route path="employee-insert" element={<EmployeeInsert/>}/>
                    <Route path="forget-password" element={<ForgetPassword/>}/>
                    <Route path="matrix-library" element={<MatrixLibrary/>}/>
                    <Route path="matrix-library-create" element={<MatrixLibraryCreate/>}/>
                    <Route path="management-employee-matrix" element={<EmployeeWillMatrixAdmin/>}/>
                    <Route path="contact-person" element={<Contact/>}/>
                    <Route path="employee-idp-admin" element={<EmployeeIDPAdmin/>}/>
                    <Route path="user-email-update" element={<SupervisorUserEmailUpdate/>}/>
                    <Route path="EmployeeTaskList" element={<EmployeeTaskList/>}/>
                    <Route path="SupervisorRemarksForTaskList" element={<SupervisorRemarksForTaskList/>}/>
                    <Route path="EmployeeWiseActionPlan" element={<EmployeeWiseActionPlan/>}/>
                    <Route path="TaskListReport" element={<TaskListReport/>}/>
                    <Route path="TaskListDashboard" element={<TaskListDashboard/>}/>
                    <Route path="PMSCycleReport" element={<PMSCycleReport/>}/>
                    <Route path="EvaluationReportSummary" element={<EvaluationReportSummary/>}/>
                    <Route path="PromotionRecommendation" element={<PromotionRecommendation/>}/>
                    <Route path="PromotionRecommendationForHOD" element={<PromotionRecommendationForHOD/>}/>
                    <Route path="PromotionRecommendationForDivisionHead" element={<PromotionRecommendationForDivisionHead/>}/>
                    <Route path="PromotionRecommendationForHR" element={<PromotionRecommendationForHR/>}/>
                    <Route path="HeadSetup" element={<HeadSetup/>}/>
                    <Route path="EmployeePromotionReport" element={<EmployeePromotionReport/>}/>
                    <Route path="SupervisorUserMarks" element={<SupervisorUserMarks/>}/>
                    <Route path="HodUserMarks" element={<HodUserMarks/>}/>
                    <Route path="DivisionHeadUserMarks" element={<DivisionHeadUserMarks/>}/>
                    <Route path="HRUserMarks" element={<HRUserMarks/>}/>
                </Routes>
            </BrowserRouter>
            <ToastContainer/>

        </>
    );
}

export default App;
